import { useLocation } from 'react-router';

export const useHideOnPaths = (paths: string[]) => {
    const { pathname } = useLocation();

    return paths.some((path) => pathname.includes(path));
};